import { render, staticRenderFns } from "./moduleFour.vue?vue&type=template&id=37b017d5&scoped=true&"
import script from "./moduleFour.vue?vue&type=script&lang=js&"
export * from "./moduleFour.vue?vue&type=script&lang=js&"
import style0 from "./moduleFour.vue?vue&type=style&index=0&id=37b017d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b017d5",
  null
  
)

export default component.exports